<template>
  <div>
    <div class="pdfarea">
      <button id="prev" class="btn btn-outline-secondary prev">Previous</button>
      <button id="next" class="btn btn-outline-secondary next">Next</button>
      &nbsp; &nbsp;
      <span>
        Page:
        <span id="page_num" class="page_num"></span> /
        <span id="page_count" class="page_count"></span>
      </span>
      <canvas id="the-canvas" class="the-canvas" :style="isMobile? 'width:100%;height: auto;' : 'max-width: 500px;height: auto;'"></canvas>
    </div>
  </div>
</template>

<script>
import pdfjs from "pdfjs-dist";
import api from "@/api";
import helper from "@/vueHelper"

export default {
  name: "PDFBox",
  props: {
    data: Object,
    isMobile: Boolean
  },
  mounted() {
    /*******************************************/
    /***********Replace by imageBox*************/
    /*******************************************/
    var vm = this;
    api.request(
      this,
      "post",
      "/userBuildForm/getfile",
      {
        SessionID: helper.getSessionID(),
        LocaleCode: helper.getLocaleCode(),
        Parameters: {
            Attachment: vm.data
        }
      },
      function(r) {
        vm.init(r.data.file);
      },
      function(r) {
        this.sessionErrorMsg = this.$store.state.errorMsg;
      }
    ); 
  },
  methods: {
    init(pdf){
      var $vm = this;
      //var pdfData = atob(pdf);
      var pdfData = pdf;
      console.log(pdf);

      var pdfjsLib = pdfjs; //GET js file from import

      pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.4.456/pdf.worker.min.js`; //SET pdf reader path TODO: Set to local path
      ////cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js
      var pdfDoc = null,
        pageNum = 1,
        pageRendering = false,
        pageNumPending = null,
        scale = 3,
        canvas = $($vm.$el).find('.the-canvas')[0], //)document.getElementById("the-canvas"),
        ctx = canvas.getContext("2d");

      /**
       * Get page info from document, resize canvas accordingly, and render page.
       * @param num Page number.
       */
      function renderPage(num) {
        pageRendering = true;
        // Using promise to fetch the page
        pdfDoc.getPage(num).then(function(page) {
          var viewport = page.getViewport({ scale: scale });
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };
          var renderTask = page.render(renderContext);

          // Wait for rendering to finish
          renderTask.promise.then(function() {
            pageRendering = false;
            if (pageNumPending !== null) {
              // New page rendering is pending
              renderPage(pageNumPending);
              pageNumPending = null;
            }
          });
        });

        // Update page counters
        $($vm.$el).find('.page_num').html(num); //document.getElementById("page_num").textContent = num;
      }

      /**
       * If another page rendering in progress, waits until the rendering is
       * finised. Otherwise, executes rendering immediately.
       */
      function queueRenderPage(num) {
        if (pageRendering) {
          pageNumPending = num;
        } else {
          renderPage(num);
        }
      }

      /**
       * Displays previous page.
       */
      function onPrevPage() {
        if (pageNum <= 1) {
          return;
        }
        pageNum--;
        queueRenderPage(pageNum);
      }
      $($vm.$el).find('.prev').click(onPrevPage); //document.getElementById("prev").addEventListener("click", onPrevPage);

      /**
       * Displays next page.
       */
      function onNextPage() {
        if (pageNum >= pdfDoc.numPages) {
          return;
        }
        pageNum++;
        queueRenderPage(pageNum);
      }
      $($vm.$el).find('.next').click(onNextPage); //document.getElementById("next").addEventListener("click", onNextPage);

      /**
       * Asynchronously downloads PDF.
       */
      function callGetDocment (response) {
        PDFJS.getDocument(response).then(function getPdfHelloWorld(_pdfDoc) {
        pdfDoc = pdfDoc_;
        $($vm.$el).find('.page_count').html(pdfDoc.numPages); //document.getElementById("page_count").textContent = pdfDoc.numPages;

        // Initial/first page rendering
        renderPage(pageNum);
        });
      }

      function getBinaryData (url) {
        var xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            callGetDocment(e.currentTarget.response);
        };

        xhr.onerror = function  () {
            alert("xhr error");
        }

        xhr.send();
      }

      getBinaryData(pdfData);

      // pdfjsLib.getDocument(pdfData).promise.then(function(pdfDoc_) { //{ data: pdfData }
      //   pdfDoc = pdfDoc_;
      //   $($vm.$el).find('.page_count').html(pdfDoc.numPages); //document.getElementById("page_count").textContent = pdfDoc.numPages;

      //   // Initial/first page rendering
      //   renderPage(pageNum);
      // });
    }
  }
};
</script>

<style scoped>
.pdfarea {
  padding-bottom: 10px;
}
</style>